import { render } from "./Paragraph.vue?vue&type=template&id=c9bbc8fe&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"

import "./Paragraph.vue?vue&type=style&index=0&id=c9bbc8fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9bbc8fe"]])

export default __exports__